import React from 'react'
import Link from 'gatsby-link'
import './style.css'
import logo from '../../assets/images/death-logo.png'
import { slide as Menu } from 'react-burger-menu'

const HeaderMain = ({ siteTitle }) => (
    <div>
        <div className="site-header desktop-menu">
            <div className="header-content-container">
                <Link className="header-link" activeClassName="active" to="/timeline">Timeline</Link>
                <Link className="header-link" activeClassName="active" to="/research">Research</Link>
                <Link to="/"><img src={logo} /></Link>
                <Link  className="header-link" activeClassName="active" to="/drivers">Drivers</Link>
                <Link className="header-link" activeClassName="active" to="/futures">Futures</Link>
            </div>
        </div>
        <div className="mobile-menu">
            <Menu>
                <Link className="mobile-header-link" activeClassName="active-mobile" to="/">Home</Link>
                <Link className="mobile-header-link" activeClassName="active-mobile" to="/research">Research</Link>
                <Link className="mobile-header-link" activeClassName="active-mobile" to="/timeline">Timeline</Link>
                <Link  className="mobile-header-link" activeClassName="active-mobile" to="/drivers">Drivers</Link>
                <Link className="mobile-header-link" activeClassName="active-mobile" to="/futures">Futures</Link>
          </Menu>
        </div>
    </div>
)

export default HeaderMain
